// カードを新規追加するモーダルのコンポーネント

import React, { useState } from 'react';

import './NewCardSettingModal.css';

// React Modalで実装
import Modal from 'react-modal';
import { useTranslation } from "react-i18next";

Modal.setAppElement("#root");

const NewCardSetting2 = ({modalIsOpen, closeModal, movePrevPage, currentCard, setCurrentCard, selectedOption, previewImage, saveCard, packageTypeList, singleCardTags}) => {
    const { t } = useTranslation();

    const submitRegister = () => {
        let isSaved = saveCard();
        if (isSaved) {
            closeModal();
        } else {
            // alert("カードの登録に失敗しました。");
        }
    }

    return (
        <>
        <Modal
            isOpen={modalIsOpen}
            onRequestClose={closeModal}
            className="new-card-setting-modal"
            overlayClassName="new-card-setting-modal-overlay"
            contentLabel="Example Modal"
        >
            <div className="new-card-setting-modal-title">{t('new_card_setting2.title')}</div>
            <div className='progressbar-mini-box'>
                <ul className="progressbar-mini">
                    <li className="active"></li>
                    <li className="active"></li>
                </ul>
            </div>
            <div className="clearfix"></div>
            <div className="new-card-setting-modal-form">
                <dl className="oripa-info-confirm oripa-info-modal-dl-half">
                    <dt className="oripa-info-modal-dl-title">{t('new_card_setting2.image')}</dt>
                    <dd className="oripa-info-modal-dl-text">
                        <img src={previewImage} className="new-card-setting-modal-form-preview-image" />
                    </dd>
                </dl>
                <div className="clearfix"></div>
                <dl className="oripa-info-confirm">
                    <dt className="oripa-info-modal-dl-title clear-left">{t('new_card_setting2.name')}</dt>
                    <dd className="oripa-info-modal-dl-text">
                        <input type="text" className="oripa-info-modal-dl-input" value={currentCard.name} onChange={(e) => setCurrentCard({...currentCard, name: e.target.value})} />
                    </dd>
                </dl>
                <div className="clearfix"></div>
                <div className="line"></div>
                <dl className="oripa-info-confirm">
                    <dt className="oripa-info-modal-dl-title">{t('single_card.tag')}</dt>
                    <dd className="oripa-info-modal-dl-text">
                        <select className="oripa-info-modal-dl-select" value={currentCard.tagId ?? ''} 
                            onChange={(e) => {
                                const tagId = e.target.value;
                                let tagName = null;
                                const singleCardTag = singleCardTags.find( sct=> {
                                    return parseInt(sct.id) === parseInt(tagId);
                                })
                                if (singleCardTag) {
                                    tagName = singleCardTag.tag_name;
                                }
                                setCurrentCard({...currentCard, tagId, tagName})}}
                            >
                            <option value="0"></option>
                            {singleCardTags.map(sct => (<option key={sct.id} value={sct.id}>{t("single_card_tags." + sct.tag_name)}</option>))}
                        </select>
                    </dd>
                    <dt className="oripa-info-modal-dl-title clear-left">{t('single_card.kinds')}</dt>
                    <dd className="oripa-info-modal-dl-text">
                        <select className="oripa-info-modal-dl-select" value={currentCard.singleTypeId ?? "1"} 
                            onChange={(e) => {
                                const singleTypeId = e.target.value;
                                const packageType = packageTypeList.find( ptl=> {
                                    return ptl.package_type === singleTypeId;
                                  })

                                console.log(packageType)
                                const singleTypeName = packageType.package_type_name;
                                console.log(singleTypeName)
                                setCurrentCard({...currentCard, singleTypeId, singleTypeName})}} 
                            >
                            {packageTypeList.map(ptl => (<option key={ptl.package_type} value={ptl.package_type}>{t("package_master." + ptl.package_type_name)}</option>))}
                        </select>
                    </dd>
                    <dt className="oripa-info-modal-dl-title clear-left">{t('single_card.cards')}</dt>
                    <dd className="oripa-info-modal-dl-text">
                        <input type="text" className="oripa-info-modal-dl-input" value={currentCard.number} onChange={(e) => setCurrentCard({...currentCard, number: e.target.value})} /> {t('single_card.card')} 
                    </dd>
                    <dt className="oripa-info-modal-dl-title clear-left">{t('single_card.sales_price')}</dt>
                    <dd className="oripa-info-modal-dl-text">
                        <input type="text" className="oripa-info-modal-dl-input" value={currentCard.rewardPoint} onChange={(e) => setCurrentCard({...currentCard, rewardPoint: e.target.value})} /> {t('single_card.points')}
                    </dd>
                    <dt className="oripa-info-modal-dl-title clear-left">
                        <input type="radio" className="oripa-info-modal-dl-radio" name="psa" value="1" checked={currentCard.isPsaEnabled == "1"} onChange={(e) => setCurrentCard({...currentCard, isPsaEnabled: e.target.value})} />
                        {t('single_card.with_psa')}
                    </dt>
                    <dd className="oripa-info-modal-dl-text">
                        <input type="text" className="oripa-info-modal-dl-input" value={currentCard.psa} onChange={(e) => setCurrentCard({...currentCard, psa: e.target.value})} /> {t('single_card.score')}
                    </dd>
                    <dt className="oripa-info-modal-dl-title clear-left">
                        <input type="radio" className="oripa-info-modal-dl-radio" name="psa" value="2" checked={currentCard.isPsaEnabled == "2"} onChange={(e) => setCurrentCard({...currentCard, isPsaEnabled: e.target.value})} />
                        {t('single_card.without_psa')}
                    </dt>
                    <dd className="oripa-info-modal-dl-text"></dd>

                    <dt className="oripa-info-modal-dl-title clear-left">{t('single_card.description')}</dt>
                    <dd className="oripa-info-modal-dl-text">
                        <textarea className="shop-info-textarea" value={currentCard.description ?? ''} onChange={e => setCurrentCard({...currentCard, description: e.target.value})} />
                    </dd>

                    
                </dl>
            </div>
            <div className="clearfix"></div>
            <div className="new-card-setting-modal-button">
            <button className="new-card-setting-modal-button-cancel" onClick={movePrevPage}>{t('single_card.back')}</button>
            <button className="new-card-setting-modal-button-add" onClick={submitRegister}>{t('single_card.next')}</button>
            </div>
        </Modal>
        </>
    );
}

export default NewCardSetting2;